import React from 'react';
import './ResponsiveImg.scss';

interface Props {
    desktopImage: string;
    mobileImage?: string;
    className?: string;
}

const ResponsiveImg: React.FC<Props> = ({
    className,
    desktopImage,
    mobileImage,
}) => {
    return (
        <div className={`ResponsiveImg ${className}`}>
            <img
                src={desktopImage}
                className="ResponsiveImg--image ResponsiveImg--desktop"
            />
            <img
                src={mobileImage ? mobileImage : desktopImage}
                className="ResponsiveImg--image ResponsiveImg--mobile"
            />
        </div>
    );
};

export default ResponsiveImg;
